import { styled } from "@mui/material";
import { Skeleton } from "@kaltura/mediaspace-shared-styled";

export const CellSkeleton = styled(Skeleton)(({ theme }) => ({
    borderRadius: theme.kaltura.shape.roundness1,
    width: "100%",
    height: 20,
}));
